export default __webpack_public_path__ + "static/fall18-dbc969740c335f1a4fac719500fee58d.webp";